import { i18next as i18n, i18nextInit } from '@mv-submodules/inplant-core-fe/i18n/i18n'
import core from '@mv-submodules/inplant-core-fe/i18n'
import checklist from '@mv-submodules/inplant-checklist-fe-iblu/i18n'
import chronoframe from '@mv-submodules/inplant-chronoframe-fe/i18n'
import director from '../i18n'
import overwrites from '../i18n/overwrite'
import fermiimpianto from '@mv-submodules/inplant-fermiimpianto-fe-iblu/i18n'
import mcs from '@mv-submodules/inplant-mcs-fe-iblu/i18n'
import user from '@mv-submodules/inplant-user-fe/i18n'
import titech from '@mv-submodules/inplant-titech-fe-iblu/i18n'
import recipeControl from '@mv-submodules/vidim-recipecontrol-fe/i18n'
import components from '@mv-submodules/inplant-components-fe/i18n'
import coreAdapter from '../../inplant-coreadapter-fe/i18n'
import proximity from '@mv-submodules/vidim-proximity-fe/i18n'
import assetManager from '@mv-submodules/inplant-asset-manager-fe/i18n'

import { extend } from '@mv-submodules/inplant-core-fe/functions/objects'


i18nextInit({
  // @ts-ignore
  resources: extend(true, {
    en: {
      translation: {
        ...recipeControl.en,
        ...director.en,
        ...core.en,
        ...checklist.en,
        ...chronoframe.en,
        ...fermiimpianto.en,
        ...mcs.en,
        ...user.en,
        ...titech.en,
        ...components.en,
        ...coreAdapter.en,
        ...proximity.en,
        ...assetManager.en
      },
    },
    it: {
      translation: {
        ...recipeControl.it,
        ...director.it,
        ...core.it,
        ...checklist.it,
        ...chronoframe.it,
        ...fermiimpianto.it,
        ...mcs.it,
        ...user.it,
        ...titech.it,
        ...components.it,
        ...coreAdapter.it,
        ...proximity.it,
        ...assetManager.it
      },
    },
  }, {
    en: {
      translation: {
        ...overwrites.en,
      },
    },
    it: {
      translation: {
        ...overwrites.it,
      },
    },
  }),
})

export default i18n
